import { get } from 'lodash-es';
export function config(path, defaultValue = null) {
    return get(CONFIG, path, defaultValue);
}
